<template>
    <ul class="settingUl">
        <li>
            <span>背景颜色</span>
            <el-color-picker v-model="infoItme.bjColor"></el-color-picker>
        </li>
        <li>
            <span>页边距</span>
            <el-radio-group size="mini" v-model="infoItme.yeBj">
                <el-radio-button label="0px">无</el-radio-button>
                <el-radio-button label="15px">有</el-radio-button>
            </el-radio-group>
        </li>
        <li>
            <span>组件上边距(15px)</span>
            <el-radio-group size="mini" v-model="infoItme.sBj">
                <el-radio-button label="0px">无</el-radio-button>
                <el-radio-button label="10px">小</el-radio-button>
                <el-radio-button label="15px">大</el-radio-button>
            </el-radio-group>
        </li>
        <li>
            <span>组件下边距(15px)</span>
            <el-radio-group size="mini" v-model="infoItme.xBj">
                <el-radio-button label="0px">无</el-radio-button>
                <el-radio-button label="10px">小</el-radio-button>
                <el-radio-button label="15px">大</el-radio-button>
            </el-radio-group>
        </li>
    </ul>
</template>

<script>
export default {
  name: 'comSetting',
  props: {
    infoItme: Object
  },
  data () {
    return {

    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/comSetting.vue